import React from "react";
import { format, addDays } from "date-fns";
import { FaForward } from "react-icons/fa";
import ReactTooltip from "react-tooltip";

const DisplayInfoEni = ({ d = [], onDisplayInfoEniClick }) => {
  const formatDateNaiss = (dateStr) => {
    if (!dateStr || dateStr.length < 8) return "N/A";
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    const parsedDate = new Date(`${year}-${month}-${day}`);
    return format(addDays(parsedDate, 1), "dd/MM/yyyy");
  };

  return (
    <div className="container my-3">
      <ReactTooltip />
      {d.length > 0 && (
        <ul className="list-group list-group-flush">
          {d.map((item) => (
            <li
              key={item.CLEUNIQUE}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>
                  {item.NOMEL} {item.PRENOMEL}
                </strong>
                {item.LOCNAISS ? `, Né(e) à ${item.LOCNAISS}` : ""}
                {item.DNAISS ? ` le ${formatDateNaiss(item.DNAISS)}` : ""}
                {item.IDSECTION
                  ? `, Philo : ${item.IDSECTION.substr(1, 1)}`
                  : ""}
              </div>

              <FaForward
                data-tip="Ajouter ..."
                className="ml-4 text-primary"
                style={{
                  cursor: "pointer",
                  fontSize: "1.25rem",
                  transition: "transform 0.15s ease",
                }}
                onClick={() => onDisplayInfoEniClick(item)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DisplayInfoEni;
